import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { setTimeCounter } from "store/products/actions"
import SweetAlert from "react-bootstrap-sweetalert"
import { postExtendSession } from "helpers/backend_helper"

const ExtendSession = props => {

  const maxAllowedTime = 1200; //in seconds
  const warningTime = 100; //in seconds
  const dispatch = useDispatch()
  const [timer, setTimer] = useState()

  const [showPopUp, setShowPopUp] = useState(false)
  const [timeDifference, setTimeDiffence] = useState()

  const { timerfromstate, timelastextended } = useSelector(state => ({
    timerfromstate: state.Products.countdowntimer,
    timelastextended: state.Products.timelastextended,
  }))

  useEffect(() => {
    const interval = setInterval(() => {
      //setSeconds(seconds => seconds + 1);
      const timeDiff = (new Date().getTime() - timelastextended) / 1000
      setTimer(Number(timeDiff))
      setTimeDiffence(timeDiff)
      //console.log('timeDiff:'+timeDiff)
      if(timeDiff > (maxAllowedTime-warningTime)){
        setShowPopUp(true)
      }

      if(timeDiff > (maxAllowedTime)){
        window.location = "/logout"
      }
      
    }, 1000);
    return () => clearInterval(interval);
  }, [timelastextended]);

  const onCancel = () => {
    window.location = "/logout"
  }

  const onExtend = () => {
    setShowPopUp(false)
    postExtendSession().then(result => {
      console.log('result?.status:',result.status)
      if(result?.status == 'success'){
        dispatch(setTimeCounter(1500000))
      }
      else{
        //dispatch(setTimeCounter(60000))
      }
    })
  }

  function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " h, " : " h, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " m, " : " m, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " s" : " s") : "";
    return hDisplay + mDisplay + sDisplay; 
}

  return (
    <React.Fragment>
      Timing Out in : {secondsToHms(maxAllowedTime - timeDifference)}

      {showPopUp && <SweetAlert
        showCancel
        confirmBtnText="Stay Connected"
        cancelBtnText="Logout"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        title="Your Session is About to Expire!"
        onCancel={() => {
          onCancel()
        }}
        onConfirm={() => {
          onExtend()
        }}
      >
        Redirecting in {Math.floor(maxAllowedTime - timer)} seconds.<br></br>
      </SweetAlert>}
    </React.Fragment>
  )
}

ExtendSession.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

/*
const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}
*/
export default withRouter(ExtendSession)
/*
export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ExtendSession))
)
*/
